/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceNameQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceNameQueryOperator");
    }

    getFixupPrototypeFunction() { return ResourceNameQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ResourceNameQueryOperator>): ResourceNameQueryOperator {
        let obj = Object.assign(new ResourceNameQueryOperator(), model);
        ResourceNameQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceNameQueryOperator>): ResourceNameQueryOperator {
        if (!model) return null;
        return ResourceNameQueryOperator.newInstance(<ResourceNameQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceNameQueryOperator) {
        if (!obj) return;

        models.ResourceNameQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceNameQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceNameQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Resource names to include
     */
    resource_names: Array<string>;

}
